﻿import config from "../config"
const baseUrl = config.base_url + "sdd_warning_item/"
export default {
    page: {
        url:  baseUrl + "page/{limit}/{page}",
        type: "post",
    },
    get: {
        url:  baseUrl + "get",
        type: "get",
    },
    warningTypeList: {
        url:  baseUrl + "warningTypeList",
        type: "get",
    },
    save: {
        url:  baseUrl + "save",
        type: "post",
    },
    remove:{
        url:  baseUrl + "delete",
        type: "get",
    },
}

